// extracted by mini-css-extract-plugin
module.exports = {"noticeWrapper":"not-found-404_noticeWrapper__tPgWl","notice":"not-found-404_notice__3bxZc"};